import { useChatContext } from './ChatContext';
import { getWelcomeMessage } from '@/i18n/maps';
import { MarkdownRenderer } from '@/markdown/renderer';

export function WelcomeBubble(): JSX.Element {
  const { locale } = useChatContext();
  const source = getWelcomeMessage(locale);
  return (
    <section className="tw-relative tw-rounded-2xl tw-rounded-tl-md tw-bg-cal-surface tw-p-5 tw-overflow-hidden">
      {/* Soft gradient halo, no header row — keep the bubble minimal so it
          doesn't compete with the actual brand chrome above the chat. */}
      <span
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute -tw-top-12 -tw-left-8 tw-w-40 tw-h-40 tw-rounded-full"
        style={{
          background:
            'radial-gradient(closest-side, rgba(137,184,50,0.16), rgba(137,184,50,0) 70%)',
        }}
      />
      <div className="tw-relative tw-text-[14px] tw-text-black tw-leading-relaxed tw-space-y-2 tw-opacity-[0.60]">
        <MarkdownRenderer source={source} />
      </div>
    </section>
  );
}
